import { apiClient } from '../utils/apiClient';
import { getActiveIFSAccountId } from '../utils/ifsAccount';
export const shipmentService = {
    list: (filters) => {
        const params = new URLSearchParams();
        if (filters?.status && filters.status !== 'all')
            params.set('status', filters.status);
        if (filters?.search)
            params.set('search', filters.search);
        if (filters?.pageSize)
            params.set('pageSize', String(filters.pageSize));
        if (filters?.continuationToken)
            params.set('continuationToken', filters.continuationToken);
        const qs = params.toString();
        return apiClient.get(`/shipments-list${qs ? `?${qs}` : ''}`);
    },
    get: (id) => apiClient.get(`/shipments-get?id=${id}`),
    create: (data) => apiClient.post('/shipments-create', data),
    update: (id, data) => apiClient.put(`/shipments-update?id=${id}`, data),
    delete: (id) => apiClient.delete(`/shipments-delete?id=${id}`),
    import: (trackingNumbers) => {
        const accountId = getActiveIFSAccountId();
        const body = { trackingNumbers };
        if (accountId)
            body.accountId = accountId;
        return apiClient.post('/shipments-import', body);
    },
    refresh: (id) => apiClient.post(`/shipments-refresh?id=${id}`, {}),
};
